import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from "../assets/RCS-Logo-White.png";

const Footer = () => {
  const footerStyle = {
    backgroundColor: '#11487C',
    fontFamily: 'Poppins, sans-serif',
    position: 'relative',
    overflow: 'hidden'
  };

  const backgroundElementStyle1 = {
    position: 'absolute',
    top: '40px',
    right: '40px',
    width: '256px',
    height: '256px',
    backgroundColor: 'rgba(255, 215, 0, 0.05)',
    borderRadius: '50%',
    filter: 'blur(50px)',
    pointerEvents: 'none'
  };

  const backgroundElementStyle2 = {
    position: 'absolute',
    bottom: '40px',
    left: '40px',
    width: '384px',
    height: '384px',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '50%',
    filter: 'blur(50px)',
    pointerEvents: 'none'
  };

  const logoContainerStyle = {
    padding: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '16px'
  };

  const sectionTitleStyle = {
    color: '#FFD700',
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '16px'
  };

  const iconContainerStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 215, 0, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const socialIconStyle = {
    width: '48px',
    height: '48px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    transform: 'scale(1)'
  };

  const contactCardStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    padding: '16px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    transform: 'scale(1)'
  };

  const quickLinksStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    padding: '16px',
    border: '1px solid rgba(255, 255, 255, 0.1)'
  };

  return (
    <footer style={footerStyle}>
      {/* Background Elements */}
      <div style={backgroundElementStyle1}></div>
      <div style={backgroundElementStyle2}></div>

      <div className="container position-relative py-5">
        {/* Main Footer Content */}
        <div className="row g-4 g-lg-5">
          {/* Company Info Section */}
          <div className="col-lg-4">
            <div className="mb-4">
              {/* Logo and Company Name */}
              <div className="d-flex align-items-center mb-3">
                <div style={logoContainerStyle}>
                  <img
                    src={Logo}
                    alt="RCS Logistics Philippines"
                    style={{ height: '40px', width: 'auto', filter: 'brightness(1.1)' }}
                  />
                </div>
                <div className="ms-3 text-start">
                  <h3 className="text-white fw-bold fs-5 mb-0 text-start">RCS LOGISTICS</h3>
                  <p className="text-white-50 small mb-0 text-start">Philippines</p>
                </div>
              </div>

              <p className="text-white-75 lh-base text-start" style={{ maxWidth: '400px', color: 'rgba(255,255,255,0.8)' }}>
                RCS Logistics Philippines provides exceptional transport services
                with reliability, innovation, and commitment to excellence in every
                shipment.
              </p>
            </div>

            {/* Social Media Links */}
            <div className="text-start">
              <h4 style={{ color: '#FFD700', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>
                Follow Us
              </h4>
              <div className="d-flex gap-3">
                <a
                  href="https://www.facebook.com/share/1Bnt6YGWMY/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={socialIconStyle}
                  aria-label="Facebook"
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.1)';
                    e.target.style.backgroundColor = '#FFD700';
                    e.target.querySelector('i').style.color = '#11487C';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.target.querySelector('i').style.color = 'white';
                  }}
                >
                  <i className="fab fa-facebook-f text-white" style={{ fontSize: '18px', transition: 'color 0.3s ease' }}></i>
                </a>
                <a
                  href="https://www.instagram.com/rcslogistics?igsh=a3V2NWg2dHgxeDdt"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={socialIconStyle}
                  aria-label="Instagram"
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.1)';
                    e.target.style.backgroundColor = '#FFD700';
                    e.target.querySelector('i').style.color = '#11487C';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.target.querySelector('i').style.color = 'white';
                  }}
                >
                  <i className="fab fa-instagram text-white" style={{ fontSize: '18px', transition: 'color 0.3s ease' }}></i>
                </a>
              </div>
            </div>
          </div>

          {/* Office Information */}
          <div className="col-lg-4">
            <h4 className="d-flex align-items-center mb-4" style={sectionTitleStyle}>
              <div style={iconContainerStyle} className="me-2">
                <i className="fas fa-building" style={{ color: '#FFD700', fontSize: '14px' }}></i>
              </div>
              Our Main Office
            </h4>

            <div style={contactCardStyle}>
              <div className="d-flex align-items-start">
                <div style={{ ...iconContainerStyle, backgroundColor: 'rgba(30, 78, 114, 0.2)', marginTop: '4px' }}>
                  <i className="fas fa-map-marker-alt" style={{ color: '#FFD700', fontSize: '14px' }}></i>
                </div>
                <div className="ms-3 text-start">
                  <h5 className="text-white fw-semibold mb-1" style={{ fontSize: '16px' }}>Address</h5>
                  <p className="small mb-0 lh-base text-start" style={{ color: 'rgba(255,255,255,0.8)' }}>
                    Retail C, GF, BM ONE Building <br />
                    Amvel Business Park <br />
                    Ninoy Aquino Ave San Dionisio, Paranaque
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="col-lg-4">
            <h4 className="d-flex align-items-center mb-4" style={sectionTitleStyle}>
              <div style={iconContainerStyle} className="me-2">
                <i className="fas fa-phone" style={{ color: '#FFD700', fontSize: '14px' }}></i>
              </div>
              Contact Us
            </h4>

            {/* Phone */}
            <div style={contactCardStyle} className="mb-3">
              <div className="d-flex align-items-start">
                <div style={{ ...iconContainerStyle, backgroundColor: 'rgba(30, 78, 114, 0.2)', marginTop: '4px' }}>
                  <i className="fas fa-phone" style={{ color: '#FFD700', fontSize: '14px' }}></i>
                </div>
                <div className="ms-3 text-start">
                  <h5 className="text-white fw-semibold mb-1" style={{ fontSize: '16px' }}>Phone</h5>
                  <a href="tel:+6288250200" className="small mb-0 text-start d-block text-decoration-none" style={{ color: 'rgba(255,255,255,0.8)' }}>
                    (02) 88250200
                  </a>
                  <a href="tel:+639177096992" className="small mb-0 text-start d-block text-decoration-none" style={{ color: 'rgba(255,255,255,0.8)' }}>
                    +63 917 709 6992
                  </a>
                </div>
              </div>
            </div>

            {/* Email */}
            <a
              href="mailto:sales@rcsphil.com"
              style={contactCardStyle}
              className="d-flex align-items-center mb-3"
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.02)';
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
              }}
            >
              <div style={{ ...iconContainerStyle, backgroundColor: 'rgba(30, 78, 114, 0.2)' }}>
                <i className="fas fa-envelope" style={{ color: '#FFD700', fontSize: '14px' }}></i>
              </div>
              <div className="ms-3 text-start">
                <p className="text-white fw-semibold mb-0" style={{ fontSize: '16px' }}>Email</p>
                <p className="small mb-0 text-start" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  sales@rcsphil.com
                </p>
              </div>
            </a>

            {/* Hours */}
            <div style={contactCardStyle} className="mb-4">
              <div className="d-flex align-items-center">
                <div style={{ ...iconContainerStyle, backgroundColor: 'rgba(30, 78, 114, 0.2)' }}>
                  <i className="fas fa-clock" style={{ color: '#FFD700', fontSize: '14px' }}></i>
                </div>
                <div className="ms-3 text-start">
                  <h5 className="text-white fw-semibold mb-0" style={{ fontSize: '16px' }}>Hours</h5>
                  <p className="small mb-0 text-start" style={{ color: 'rgba(255,255,255,0.8)' }}>
                    Mon-Fri: 8:30 AM - 5:30 PM
                  </p>
                  <p className="small mb-0 text-start" style={{ color: 'rgba(255,255,255,0.8)' }}>
                    Sat: 8:30 AM - 12:30 PM
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div style={quickLinksStyle}>
              <h5 className="text-white fw-semibold mb-3 text-start" style={{ fontSize: '16px' }}>Quick Links</h5>
              <div className="d-flex flex-column gap-2">
                <a
                  href="https://rcsphtracking.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none small d-flex align-items-center"
                  style={{ color: 'rgba(255,255,255,0.8)', transition: 'color 0.3s ease' }}
                  onMouseEnter={(e) => e.target.style.color = '#FFD700'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}
                >
                  <i className="fas fa-search me-2" style={{ fontSize: '12px' }}></i>
                  Track Shipment
                </a>
                <a
                  href="/aboutUs"
                  className="text-decoration-none small d-flex align-items-center"
                  style={{ color: 'rgba(255,255,255,0.8)', transition: 'color 0.3s ease' }}
                  onMouseEnter={(e) => e.target.style.color = '#FFD700'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}
                >
                  <i className="fas fa-info-circle me-2" style={{ fontSize: '12px' }}></i>
                  About Us
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-5 pt-4" style={{ borderTop: '1px solid rgba(255,255,255,0.2)' }}>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
            {/* Copyright */}
            <div className="text-center text-md-start">
              <p className="small mb-0" style={{ color: 'rgba(255,255,255,0.8)' }}>
                © 2026 RCS Logistics Philippines. All Rights Reserved | 
                <a 
                  href="/privacy" 
                  className="text-decoration-none ms-1"
                  style={{ color: 'rgba(255,255,255,0.8)', transition: 'color 0.3s ease' }}
                  onMouseEnter={(e) => e.target.style.color = '#FFD700'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(255,255,255,0.8)'}
                >
                  Privacy Policy
                </a>
              </p>
            </div>

            {/* Designed By */}
            <div className="text-center text-md-end">
              <p className="small mb-1" style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Designed By:</p>
              <a
                href="https://divinesoftwaresystems.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none d-inline-flex align-items-center small fw-semibold"
                style={{ color: '#FFD700', transition: 'color 0.3s ease' }}
                onMouseEnter={(e) => e.target.style.color = 'white'}
                onMouseLeave={(e) => e.target.style.color = '#FFD700'}
              >
                <i className="fas fa-code me-1" style={{ fontSize: '12px' }}></i>
                Divine Software Systems
                <i className="fas fa-external-link-alt ms-1" style={{ fontSize: '12px' }}></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
